import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import ModalWithClearButton from "@src/sharedComponents/Modal/ModalWithClearButton";
import Text from "@src/sharedComponents/Typography/Text";

import { strings } from "./strings";

import styles from "./Share.module.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCreateCustomModel: () => void;
}

/**
 * Modal that explains custom model creation and provides options to continue or cancel
 */
const CreateCustomModelModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onCreateCustomModel,
}) => {
  return (
    <ModalWithClearButton
      closeModal={onClose}
      isOpen={isOpen}
      modalStyle={{ zIndex: 9999 }}
    >
      <Text variant="title1">{strings.MODAL_TITLE}</Text>
      <br />
      <Text variant="body">{strings.MODEL_TEXT_ONE}</Text>
      <br />
      <Text variant="body">{strings.MODEL_TEXT_TWO}</Text>
      <br />
      <Text variant="body">{strings.MODEL_TEXT_THREE}</Text>
      <div className={styles.footer}>
        <Button
          text="Cancel"
          onClick={onClose}
          variant="outlined"
          buttonType="primary"
        />
        <Button
          text="Continue"
          variant="contained"
          buttonType="primary"
          onClick={onCreateCustomModel}
        />
      </div>
    </ModalWithClearButton>
  );
};

export default CreateCustomModelModal;
